document.addEventListener('DOMContentLoaded', function () {
  var citySelect = document.getElementById('delivery-city');
  var selectedCityDisplay = document.getElementById('selected-city-value');
  var selectedCityContainer = document.querySelector('.selected-city');
  var priceDisplay = document.getElementById('delivery-price-value');
  var customer_email = document.getElementById('c_email');
  var priceContainer = document.querySelector('.delivery-price');
  //var priceHiddenInput = document.getElementById('delivery-price-hidden');
  var dateInput = document.getElementById("delivery-date");
  var timeslotSelect = document.getElementById("timeslot");
  var specificTimeslot = document.getElementById("specific-time-select");
  var card_message_to = document.getElementById("card_message_to");
  var card_message_from = document.getElementById("card_message_from");
  var phone = document.getElementById("phone");
  var phone_code = document.getElementById("phone_code");
  var countryCode = 'SG'; // Fallback to 'SG'
  var recipient_name = document.getElementById('recipient_name');
  var recipient_last_name = document.getElementById('recipient_last_name');
  var recipient_phone = document.getElementById('recipient_phone');
  var recipient_phone_code = document.getElementById('recipient_phone_code');
  var recipient_address = document.getElementById('recipient_address');
  var zip = document.getElementById('zip');
  var stickyAddToCartBtn = document.getElementById('product-sticky-add-to-cart');
  
  //var countryCode = Shopify?.country || 'SG'; // Fallback to 'SG'

  //cart occasion
  var occasionSelect = document.getElementById('occasion');
  var messageTemplateSelect = document.getElementById('message_template');
  var card_message = document.getElementById('card_message');
  
  // Helper to format currency
  function formatCurrency(value) {
    return new Intl.NumberFormat('sg-SG', { style: 'currency', currency: 'SGD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
  }

  // Disable add-to-cart buttons and hide elements
  function disableAddToCart() {
    var addToCartBtn = document.getElementById('product-add-to-cart');

    if (addToCartBtn) {
      addToCartBtn.textContent = 'Sold Out';
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
    }
    if (stickyAddToCartBtn) {
      stickyAddToCartBtn.textContent = 'Sold Out';
      stickyAddToCartBtn.disabled = true;
      stickyAddToCartBtn.classList.add('disabled');
    }
    $(".productView-payment").hide();
    $(".global-checkbox").hide();
    $(".quantity__container").hide();
  }

  // Fetch and populate timeslots for a given date
  function fetchTimeslots(selectedDate) {
    if (!selectedDate || !timeslotSelect) return;
    var apiUrl = `https://api.floweradvisor.com/api/timeslot?domain_alias=fa.com.sg&country_code=${countryCode}&date=${selectedDate}&recipient_city=`+ sessionStorage.getItem('selected_city') +`&shopify_product_ids=`+productIdsString;
    timeslotSelect.innerHTML = `<option value="">Loading...</option>`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        timeslotSelect.innerHTML = "";
        specificTimeslot.innerHTML = "";
        if (data.error === 0 && Array.isArray(data.data) && data.data.length > 0) {
          timeslotSelect.innerHTML = `<option value="">Select a time slot</option>`;
          data.data.forEach(slot => {
            var option = document.createElement("option");
            option.value = slot.idx;
            option.textContent = slot.text;
            option.setAttribute("data-specifictime", slot.is_specific_timing);
            option.setAttribute("data-charge", slot.charge);
            option.setAttribute("data-start-time", slot.start_time);
            option.setAttribute("data-end-time", slot.end_time);
            option.setAttribute('data-cutoff-time', slot.cutoff_time);
            timeslotSelect.appendChild(option);
          });

          // Set stored timeslot if valid
          var storedTimeslot = sessionStorage.getItem('selected_timeslot');
          console.log('Timeslots:', data.data, 'Stored Timeslot:', storedTimeslot);
          if (storedTimeslot && data.data.some(slot => String(slot.idx) === storedTimeslot)) {
            // Delay to ensure DOM update
            setTimeout(() => {
              timeslotSelect.value = storedTimeslot;      
              var ts = document.getElementById('timeslot');
              var selectedOption = ts.options[storedTimeslot];

              console.log('Set timeslotSelect.value to:', storedTimeslot);
              if(selectedOption.getAttribute('data-specifictime') == 1){
                //show specific time
                document.getElementById("specific-time-div").style.display = "block";
                

                var start_time = parseInt(selectedOption.getAttribute('data-start-time')); // e.g. 10
                var end_time   = parseInt(selectedOption.getAttribute('data-end-time'));   // e.g. 20

                var specificTimeSelect = document.getElementById('specific-time-select');
                specificTimeSelect.innerHTML = ""; // Clear old options

                for (var hour = start_time; hour <= end_time; hour++) {
                  var option = document.createElement("option");
                  var startLabel = (hour < 10 ? "0" : "") + hour + ":00";
                  var endLabel   = (hour + 1 < 10 ? "0" : "") + (hour + 1) + ":00";

                  option.value = startLabel + " - " + endLabel;
                  option.text  = startLabel + " - " + endLabel;

                  specificTimeSelect.appendChild(option);
                }

              }
              else{
                document.getElementById("specific-time-div").style.display = "none";
              }
            }, 0);
          }
        } else {
          timeslotSelect.innerHTML = `<option value="">No slots available</option>`;
          if(data.message != ''){
            alert(data.message);
          }
        }
      })
      .catch(error => {
        console.error("Error fetching time slots:", error);
        timeslotSelect.innerHTML = `<option value="">Error loading slots</option>`;
      });
  }

  if(stickyAddToCartBtn){
      stickyAddToCartBtn.addEventListener('click', function () {
          setTimeout(function() {window.location='/cart'; }, 2000);
     });
  }

  if (citySelect) {
    var product_code = document.getElementById('product-sku-hidden').value;

    // Fetch city data
    fetch(`https://api.floweradvisor.com/api/city?country_code=${countryCode}&product_code=${product_code}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        var result = data.data;
        console.log('Available cities:', data);
        if (result.length === 0) {
          disableAddToCart();
          citySelect.innerHTML = `<option value="">No cities available</option>`;
        } else {
          citySelect.innerHTML = `<option value="">Select a city</option>`;
          result.forEach(city => {
            var option = document.createElement('option');
            option.value = city.name.replace(/\s+/g, '_').toLowerCase();
            if(city.charge == 0){
              option.textContent = `${city.name} - Free`;
            }
            else{
              option.textContent = `${city.name} - ${formatCurrency(city.charge)}`;  
            }
            
            option.dataset.price = city.charge;
            citySelect.appendChild(option);
          });

          // Set stored city if valid
          var storedCity = sessionStorage.getItem('selected_city');
          if (storedCity && result.some(city => city.name.replace(/\s+/g, '_').toLowerCase() === storedCity)) {
            citySelect.value = storedCity;
            var selectedOption = citySelect.selectedOptions[0];
            if (selectedOption) {
              //priceHiddenInput.value = selectedOption.dataset.price;
              Shopify.city = storedCity;
              if (selectedCityDisplay) selectedCityDisplay.textContent = selectedOption.textContent.split(' - ')[0];
              if (priceDisplay) priceDisplay.textContent = formatCurrency(selectedOption.dataset.price);
            }
          }
        }

        
      })
      .catch(error => {
        console.error('Error fetching cities:', error);
        citySelect.innerHTML = `<option value="">Unable to load cities</option>`;
      });

    // Update city, price, and persist on change
    citySelect.addEventListener('change', function () {
      var selectedValue = citySelect.value;
      var selectedOption = citySelect.selectedOptions[0];
      var selectedPrice = selectedOption ? selectedOption.dataset.price : '';

      if (selectedPrice !== '') {
        //priceHiddenInput.value = selectedPrice;
        if (priceDisplay) priceDisplay.textContent = formatCurrency(selectedPrice);
      } else {
        //priceHiddenInput.value = '';
        if (priceDisplay) priceDisplay.textContent = '';
      }
      if (selectedCityDisplay) selectedCityDisplay.textContent = selectedOption ? selectedOption.textContent.split(' - ')[0] : '';

      Shopify.city = selectedValue;
      sessionStorage.setItem('selected_city', selectedValue); // Persist city

      // Refetch timeslots if date is selected
      var selectedDate = dateInput ? dateInput.value : '';
      if (selectedDate && selectedValue) {
        fetchTimeslots(selectedDate);
      }
    });
  }


  function fetchMessageTemplate(occasion_code){
    fetch(`https://api.floweradvisor.com/api/card-message-template/`+occasion_code, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        var result = data.data;
        console.log('message template:', result);
        if (result.length === 0) {
          messageTemplateSelect.innerHTML = `<option value="">No Template for This Occasion</option>`;
        } else {
          messageTemplateSelect.innerHTML = `<option value="">Try Our Template message</option>`;
          result.forEach(occasion => {
            var option = document.createElement('option');
            option.value = occasion.message;
            option.textContent = occasion.title;
            messageTemplateSelect.appendChild(option);
          });
          
        }        
      })
      .catch(error => {
        console.error('Error fetching occasions:', error);
        messageTemplateSelect.innerHTML = `<option value="">Unable to load occasions</option>`;
      });

    messageTemplateSelect.addEventListener('change', function () {
      var selectedValue = messageTemplateSelect.value;
      console.log(selectedValue);
      card_message.value = selectedValue;
      sessionStorage.setItem('card_message', selectedValue);
    });  
  }
  
  if(card_message){
    var card_message_stored = sessionStorage.getItem('card_message');
    card_message.value = card_message_stored;

    card_message.addEventListener('blur', function () {
      var card_message_updated = card_message.value;
      sessionStorage.setItem('card_message', card_message_updated);
    });
  }

  if(card_message_to){
    var card_message_to_stored = sessionStorage.getItem('card_message_to');
    card_message_to.value = card_message_to_stored;

    card_message_to.addEventListener('blur', function () {
      var card_message_to_updated = card_message_to.value;
      sessionStorage.setItem('card_message_to', card_message_to_updated);
    });
  }

  if(card_message_from){
    var card_message_from_stored = sessionStorage.getItem('card_message_from');
    card_message_from.value = card_message_from_stored;

    card_message_from.addEventListener('blur', function () {
      var card_message_from_updated = card_message_from.value;
      sessionStorage.setItem('card_message_from', card_message_from_updated);
    });
  }
  
  if(occasionSelect){
    fetch(`https://api.floweradvisor.com/api/occasions`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        var result = data.data;
        console.log('Occasions:', result);
        if (result.length === 0) {
          occasionSelect.innerHTML = `<option value="">No occasion available</option>`;
        } else {
          occasionSelect.innerHTML = `<option value="">Select occasions</option>`;
          var skipOccasions = ['ANNI', 'CNVDAY','NEW','WHIT','FN','EAS','JB','PASS','SEC','TEACDAY'];
          

          for (var occasion of result) {
            if (skipOccasions.includes(occasion.code)) {
              continue; // properly skips to next iteration
            }
          
            var option = document.createElement('option');
            option.value = occasion.code;
            option.textContent = occasion.name;
            occasionSelect.appendChild(option);
          }
          

          var storedOccasion = sessionStorage.getItem('selected_occasion');
          if (storedOccasion && result.some(occasion => occasion.code === storedOccasion)) {
            occasionSelect.value = storedOccasion;
            fetchMessageTemplate(storedOccasion);
          }
          
        }        
      })
      .catch(error => {
        console.error('Error fetching occasions:', error);
        occasionSelect.innerHTML = `<option value="">Unable to load occasions</option>`;
      });

    occasionSelect.addEventListener('change', function () {
      var selectedValue = occasionSelect.value;
      
      sessionStorage.setItem('selected_occasion', selectedValue); // Persist city

      if (selectedValue) {
        fetchMessageTemplate(selectedValue);
      }
    });
    
  }
  
  if (dateInput) {
    var today = new Date().toISOString().split("T")[0];
    dateInput.setAttribute("min", today);
    var storedDate = sessionStorage.getItem('selected_date');
    if (storedDate && storedDate >= today && dateInput) {
      dateInput.value = storedDate;
      if (dateInput.value) {
        fetchTimeslots(storedDate);
      }
    }
    
    // Update date, fetch timeslots, and persist on change
    dateInput.addEventListener("change", function () {
      var selectedDate = dateInput.value;
      if (selectedDate) {
        sessionStorage.setItem('selected_date', selectedDate); // Persist date
        fetchTimeslots(selectedDate);
      } else {
        sessionStorage.removeItem('selected_date');
        if (timeslotSelect) {
          timeslotSelect.innerHTML = `<option value="">Select a time slot</option>`;
        }
      }
    });
  }

  if (timeslotSelect) {
  timeslotSelect.addEventListener('change', function () {
    var selectedOption = timeslotSelect.selectedOptions[0]; // get the selected option
    var selectedTimeslot = selectedOption.value;
    var selectedIndex = timeslotSelect.selectedIndex; 
    
    var isSpecificTime = selectedOption.getAttribute("data-specifictime");

    if (selectedTimeslot) {
      sessionStorage.setItem('selected_timeslot', selectedTimeslot);
    } else {
      sessionStorage.removeItem('selected_timeslot');
    }
    const cutoffTime = selectedOption.dataset.cutoffTime;
    document.getElementById('cutoffTime').value = cutoffTime || '';
    sessionStorage.setItem('cutoffTime', cutoffTime);


    if (isSpecificTime == "1") {
      document.getElementById("specific-time-div").style.display = "block";
      var ts = document.getElementById('timeslot');
      var selectedOption = ts.options[selectedIndex];
      var ts_text = selectedOption.text;
      var start_time = parseInt(selectedOption.getAttribute('data-start-time')); 
      var end_time   = parseInt(selectedOption.getAttribute('data-end-time'));   
      var charge = selectedOption.getAttribute('data-charge');

      var specificTimeSelect = document.getElementById('specific-time-select');
      specificTimeSelect.innerHTML = ""; // Clear old options

      let now = new Date();
      // Add 4 hours
      now.setHours(now.getHours() + 4);
      // Get the updated hour
      let current_hour = now.getHours();

      // Format as YYYY-MM-DD
      let dateOnly = now.toISOString().split('T')[0];

      if(dateOnly == document.getElementById("delivery-date").value && current_hour > start_time){
        start_time = current_hour;
      }



      for (var hour = start_time; hour <= end_time; hour++) {
        var option = document.createElement("option");
        var startLabel = (hour < 10 ? "0" : "") + hour + ":00";
        var endLabel   = (hour + 1 < 10 ? "0" : "") + (hour + 1) + ":00";

        option.value = startLabel + " - " + endLabel;
        option.text  = startLabel + " - " + endLabel;

        specificTimeSelect.appendChild(option);
      }

      //adding charge

      if (ts_text.includes('Specific Timing 1')) {
        // Add fee product to cart
        updateCharge('46757915853036');
      }
      else if (ts_text.includes('Specific Timing 2')) {
        // Add fee product to cart
        updateCharge('46757921849580');
      }
      else if (ts_text.includes('Specific Timing 3')) {
        // Add fee product to cart
        updateCharge('46786864480492');
      }

    } else {
      updateCharge(0);
      document.getElementById("specific-time-div").style.display = "none";
    }
  });
}

function refreshCart() {
  // fetch('/cart.js')
  //   .then(res => res.json())
  //   .then(cart => {
  //     renderCart(cart); // function to rebuild your cart DOM
  //   });
}

function renderCart(cart) {
  // let cartContainer = document.querySelector('.cart-list'); // adjust to your theme
  // cartContainer.innerHTML = '';

  // cart.items.forEach(item => {
  //   cartContainer.innerHTML += `
  //     <div class="cart-item">
  //       <div class="cart-title">${item.title}</div>
  //       <div class="cart-price">$${(item.price/100).toFixed(2)}</div>
  //       <div class="cart-qty">${item.quantity}</div>
  //       <div class="cart-total">$${(item.line_price/100).toFixed(2)}</div>
  //     </div>
  //   `;
  // });

  // // Update total price
  // document.querySelector('.cart-total-price').innerText = 
  //   '$' + (cart.total_price/100).toFixed(2);
}


const charge1Id = 46757915853036; // charge 25
const charge2Id = 46757921849580; // charge 25
const charge3Id = 46786864480492; // charge 40

function updateCharge(selectedCharge) {
  console.log('charge id :',selectedCharge);
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const charge1 = cart.items.find(i => i.variant_id == charge1Id);
      const charge2 = cart.items.find(i => i.variant_id == charge2Id);
      const charge3 = cart.items.find(i => i.variant_id == charge3Id);

      let promises = [];

      // 🔹 remove old charges first
      if (charge1) {
        promises.push(fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: charge1.key, quantity: 0 })
        }));
      }
      if (charge2) {
        promises.push(fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: charge2.key, quantity: 0 })
        }));
      }
      if (charge3) {
        promises.push(fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: charge3.key, quantity: 0 })
        }));
      }

      // 🔹 then add the correct one if needed
      Promise.all(promises).then(() => {
        if (selectedCharge == charge1Id) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: charge1Id, quantity: 1 })
          }).then(refreshCartTotal);
        } 
        else if (selectedCharge == charge2Id) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: charge2Id, quantity: 1 })
          }).then(refreshCartTotal);
        } 
        else if (selectedCharge == charge3Id) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: charge3Id, quantity: 1 })
          }).then(refreshCartTotal);
        }
        else {
          refreshCartTotal();
        }
        // refreshCart();
      });
    });
}

function refreshCartTotal() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const total = (Math.round((cart.total_price / 100).toFixed(2)));
      console.log('total',total);
      
      let subtotalEl = document.querySelector('.cart-total-subtotal .cart-total-value');
      let totalEl = document.querySelector('.cart-total-grandtotal .cart-total-value');
      subtotalEl.querySelector('.text').innerText = '$'+total;
      totalEl.querySelector('.text').innerText = '$'+total;

      
    });
}

function addChargeOnce(variantId) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const exists = cart.items.find(item => item.variant_id == variantId);
      if (exists) {
        console.log("Charge already in cart, skipping add.");
        return; // ✅ don’t add again
      }

      // If not exists, add charge
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    })
    .then(() => {
      // Reload cart total
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      const total = (cart.total_price / 100).toFixed(2);
      document.querySelector('#cart-total-value').innerText = "$ " + total;
    });
}

function removeCharge(){
  fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let feeItem = cart.items.find(i => i.variant_id == '46757915853036');
        if (feeItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: feeItem.key,
              quantity: 0
            })
          })
          .then(res => res.json())
          .then(data => console.log('Fee removed:', data));
        }
      });
}

  if(customer_email){
    var customer_email_stored = sessionStorage.getItem('customer_email');
    customer_email.value = customer_email_stored;

    customer_email.addEventListener('blur', function (e) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (e.target.value !== '' && !emailRegex.test(e.target.value)) {
        customer_email.value = '';
      } else {
        var customer_email_stored = customer_email.value;
        sessionStorage.setItem('customer_email', customer_email_stored);
      }      
    });  
  }
  
  if(phone){
    var phone_stored = sessionStorage.getItem('phone');
    if(phone_stored != null){
      phone.value = phone_stored;  
    }
    
    
    phone.addEventListener('blur', function () {
      var phone_updated = formatPhone(phone.value);
      phone.value = formatPhone(phone.value);
      sessionStorage.setItem('phone', phone_updated);
    });
  }

  if(phone_code){
    var phone_code_stored = sessionStorage.getItem('phone_code');
    if(phone_code_stored != null){
      phone_code.value = phone_code_stored;
    }
    else{
      sessionStorage.setItem('phone_code', phone_code.value);
    }
      
    

    phone_code.addEventListener('blur', function () {
      var phone_code_updated = phone_code.value;
      sessionStorage.setItem('phone_code', phone_code_updated);
    });
  }

  if(recipient_name){
    var recipient_name_stored = sessionStorage.getItem('recipient_name');
    recipient_name.value = recipient_name_stored;  
    

    recipient_name.addEventListener('blur', function () {
      var recipient_name_updated = recipient_name.value;
      sessionStorage.setItem('recipient_name', recipient_name_updated);
    });
  }

  if(recipient_last_name){
    var recipient_last_name_stored = sessionStorage.getItem('recipient_last_name');
    recipient_last_name.value = recipient_last_name_stored;  
    

    recipient_last_name.addEventListener('blur', function () {
      var recipient_last_name_updated = recipient_last_name.value;
      sessionStorage.setItem('recipient_last_name', recipient_last_name_updated);
    });
  }

  if(recipient_phone_code){
    var recipient_phone_code_stored = sessionStorage.getItem('recipient_phone_code');      
    if(recipient_phone_code_stored != null){
      recipient_phone_code.value = recipient_phone_code_stored;
    }
    else{
      sessionStorage.setItem('recipient_phone_code', recipient_phone_code.value);
    }

    recipient_phone_code.addEventListener('blur', function () {
      var recipient_phone_code_updated = recipient_phone_code.value;
      sessionStorage.setItem('recipient_phone_code', recipient_phone_code_updated);
    });
  }

  if(recipient_phone){
    var recipient_phone_stored = sessionStorage.getItem('recipient_phone');
    recipient_phone.value = recipient_phone_stored;  
    

    recipient_phone.addEventListener('blur', function () {
      var recipient_phone_updated = formatPhone(recipient_phone.value);
      recipient_phone.value = formatPhone(recipient_phone.value);
      sessionStorage.setItem('recipient_phone', recipient_phone_updated);
    });
  }

  if(recipient_address){
    var recipient_address_stored = sessionStorage.getItem('recipient_address');
    recipient_address.value = recipient_address_stored;  
    

    recipient_address.addEventListener('change', function () {
      var recipient_address_updated = recipient_address.value;
      sessionStorage.setItem('recipient_address', recipient_address_updated);
    });
  }
  
  if(zip){
    var zip_stored = sessionStorage.getItem('zip');
    zip.value = zip_stored;  
    

    zip.addEventListener('blur', function () {
      var zip_updated = zip.value;
      sessionStorage.setItem('zip', zip_updated);
    });
  }
});


function setShopifyCountry(countryCode) {
  fetch('/localization', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    body: JSON.stringify({
      country: countryCode // e.g., 'ID', 'SG', 'US'
    }),
  }).then(() => {
    location.reload(); // reload the page with new market context
  });
}





function openCityPopup() {
  document.getElementById('cityPopup').style.display = 'block';
  var dropdown = document.getElementById('cityDropdown');
  if (dropdown.options.length <= 1) {
    fetch('https://api.floweradvisor.com/api/city?country_code=SG')
      .then(response => response.json())
      .then(data => {
        dropdown.innerHTML = '';
        var result = data.data;
        result.forEach(city => {
          var option = document.createElement('option');
          option.value = city.alias;
          option.textContent = city.name;
          dropdown.appendChild(option);
        });

        // Set stored city if valid
          var storedCity = sessionStorage.getItem('selected_city');
          if (storedCity && result.some(city => city.name.replace(/\s+/g, '_').toLowerCase() === storedCity)) {
            dropdown.value = storedCity;
            var selectedOption = dropdown.selectedOptions[0];
          }


        
      });
  }
}

function formatWithEllipsis(str) {
  if (!str || typeof str !== 'string') return '';

  var words = str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
    .toLowerCase()
    .split(' ');

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1);
  } else {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1) + '...';
  }
}

function updateCitySelection(city) {
  sessionStorage.setItem('selected_city', city);
  var elements = document.getElementsByClassName('selectedCityLabel');
  for (let element of elements) {
    element.textContent = formatWithEllipsis(city);
  }
  closeCityPopup();
}

function toCamelCaseFromUnderscore(str) {
  return str
    .replace(/_/g, ' ')                      // Replace underscores with spaces
    .toLowerCase()                           // Convert to lowercase
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
}


function closeCityPopup() {
  document.getElementById('cityPopup').style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function () {
  var saved = formatWithEllipsis(sessionStorage.getItem('selected_city'));
  if (saved) {
    var elements = document.getElementsByClassName('selectedCityLabel');
    for (let element of elements) {
      element.textContent = formatWithEllipsis(saved);
    }
  }
});

function collapsedProductAddOnsWhenReady() {
  var intervalId = setInterval(() => {
    var productAddOnsElements = document.querySelector('.spice-spa-addon-product-wrapper .spice-addon-group-dropdownBox');

    if (productAddOnsElements) {
      productAddOnsElements.classList.add('spice-addon-group-active');
      clearInterval(intervalId); // Stop polling setelah elemen ditemukan
    }
  }, 200); 
}

function isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;

    return true;
}

function formatPhone(phone) {
  return phone.replace(/^0/, '');
}


collapsedProductAddOnsWhenReady();

document.addEventListener("DOMContentLoaded", () => {
  const qiscusBtn = document.querySelector(".qiscus");
  if (qiscusBtn) {
    qiscusBtn.dataset.initialContent = qiscusBtn.innerHTML;
  }

  const speedDial = document.querySelector(".speed-dial");
  if (!speedDial) return;

  const mainBtn = speedDial.querySelector(".main-btn");
  mainBtn.addEventListener("click", () => {
    speedDial.classList.toggle("open");
  });

  $(document).on("click", ".qiscus", function () {
    $(".qiscus").off("click");
    showLoading(".qiscus", "show");

    const style = document.createElement("style");
    style.innerHTML = "#qismo-widget { display: none !important; }";
    document.head.appendChild(style);

    function activateQiscus() {
      const triggerInterval = setInterval(() => {
        const triggerBtn = document.querySelector(".qcw-trigger-btn");
        if (triggerBtn) {
          triggerBtn.click();
          clearInterval(triggerInterval);

          const channelInterval = setInterval(() => {
            const channelItem = document.querySelector(".qismo-channel__item");
            if (channelItem) {
              channelItem.click();
              clearInterval(channelInterval);
              showLoading(".qiscus", "hide");
            }
          }, 300);
           showLoading(".qiscus", "hide");
        }
      }, 300);
    }

    if (window.qiscusLoaded) {
      activateQiscus();
      return;
    }

    window.qiscusLoaded = true;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://omnichannel.qiscus.com/js/qismo-v4.js";
    script.async = true;
    script.onload = () => {
      new Qismo("qduvq-ntsnc4juuknjvbl", {
        options: {
          channel_id: 130328,
          qismoIframeUrl: "https://omnichannel.qiscus.com",
          baseUrl: "https://omnichannel.qiscus.com",
          extra_fields: [],
        },
      });
      activateQiscus();
    };

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  });
});

function showLoading(target, mode = "show") {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;

  if (mode === "show") {
    el.innerHTML =
      `<svg class="spin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" fill="none" stroke="white" stroke-width="5" stroke-linecap="round" stroke-dasharray="90" stroke-dashoffset="0"></circle>
      </svg>`;
  } else if (mode === "hide") {
    // Ganti dengan SVG spesifik
    el.innerHTML = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.7994 18.3704L23.8013 18.373C24.1307 18.8032 24.2888 20.2316 22.0258 19.9779C21.3596 19.9033 20.4282 19.7715 19.3088 19.3471C18.5551 19.0613 17.8986 18.7026 17.3584 18.3522C16.4699 18.7098 15.5118 18.9296 14.5113 18.9857C13.1436 20.8155 10.9602 22 8.50001 22C7.69152 22 6.91135 21.8717 6.17973 21.6339C5.74016 21.8891 5.24034 22.1376 4.68789 22.3471C3.56851 22.7715 2.63949 22.9297 1.97092 22.9779C1.47028 23.014 1.11823 22.9883 0.944098 22.9681C0.562441 22.9239 0.219524 22.7064 0.072134 22.3397C-0.0571899 22.0179 -0.0104055 21.6519 0.195537 21.3728C0.448192 21.0283 0.680439 20.6673 0.899972 20.3011C1.32809 19.5868 1.74792 18.8167 1.85418 17.9789C1.30848 16.9383 1.00001 15.7539 1.00001 14.5C1.00001 11.5058 2.75456 8.92147 5.29159 7.71896C6.30144 3.85296 9.81755 1 14 1C18.9706 1 23 5.02944 23 10C23 11.3736 22.6916 12.6778 22.1395 13.8448C21.9492 15.5687 22.8157 17.0204 23.7994 18.3704ZM7.00001 10C7.00001 6.13401 10.134 3 14 3C17.866 3 21 6.13401 21 10C21 11.1198 20.7378 12.1756 20.2723 13.1118C20.2242 13.2085 20.1921 13.3124 20.1772 13.4194C19.9584 14.9943 20.3278 16.43 21.0822 17.8083C19.9902 17.5451 18.9611 17.0631 18.0522 16.4035C17.7546 16.1875 17.3625 16.1523 17.0312 16.3117C16.1152 16.7525 15.0879 17 14 17C10.134 17 7.00001 13.866 7.00001 10ZM5.00353 10.2543C5.11889 14.4129 8.05529 17.8664 11.9674 18.7695C11.0213 19.5389 9.8145 20 8.50001 20C7.7707 20 7.07689 19.8586 6.44271 19.6026C6.14147 19.481 5.79993 19.5133 5.52684 19.6892C5.08797 19.972 4.56616 20.2543 3.9788 20.477C3.58892 20.6248 3.23263 20.7316 2.91446 20.8083C3.24678 20.2012 3.58332 19.4779 3.73844 18.7971C3.81503 18.461 3.8572 18.1339 3.87625 17.8266C3.88848 17.6293 3.84192 17.4327 3.74245 17.2618C3.27058 16.451 3.00001 15.5086 3.00001 14.5C3.00001 12.7904 3.78 11.263 5.00353 10.2543Z" fill="white"></path>
</svg>
    `;
  } else {
    el.innerHTML = mode;
  }
}



function sendCSWA(wa_number) {
    var url = "https://wa.me/"+ wa_number + "?text=Hi+FlowerAdvisor+%2C+I+Need+Assistance+for+My+Inquiries";
    window.open(url);
}

